/**
 * Shared authentication-related constants.
 *
 * Keep auth constants here so frontend/functions modules can consume a single source of truth.
 */
export const MFA_FACTOR_IDS = {
  TOTP: 'totp',
  PHONE: 'phone',
} as const;

export type MFAFactorId = (typeof MFA_FACTOR_IDS)[keyof typeof MFA_FACTOR_IDS];

export const MFA_ERROR_CODES = {
  USER_DISABLED: 'auth/user-disabled',
  MULTI_FACTOR_AUTH_REQUIRED: 'auth/multi-factor-auth-required',
  INVALID_EMAIL: 'auth/invalid-email',
  USER_NOT_FOUND: 'auth/user-not-found',
  WRONG_PASSWORD: 'auth/wrong-password',
  INVALID_CREDENTIAL: 'auth/invalid-credential',
  INVALID_VERIFICATION_CODE: 'auth/invalid-verification-code',
  ARGUMENT_ERROR: 'auth/argument-error',
  TOO_MANY_REQUESTS: 'auth/too-many-requests',
  WEAK_PASSWORD: 'auth/weak-password',
  EMAIL_ALREADY_IN_USE: 'auth/email-already-in-use',
  INVALID_VERIFICATION_ID: 'auth/invalid-verification-id',
  REQUIRES_RECENT_LOGIN: 'auth/requires-recent-login',
  USER_TOKEN_EXPIRED: 'auth/user-token-expired',
  TOO_MANY_ENROLLMENT_ATTEMPTS: 'auth/too-many-enrollment-attempts',
} as const;

export type MFAErrorCodeKey = keyof typeof MFA_ERROR_CODES;
export type MFAErrorCode = (typeof MFA_ERROR_CODES)[MFAErrorCodeKey];

export const MFA_SMS_COOLDOWN_MS = 35000;
export const ONE_SECOND_MS = 1000;
